module.exports = __webpack_public_path__ + "static/media/icon-header-clients.592a70f2.svg";